export default __webpack_public_path__ + "static/media/footer6.5490b0b1.jpg";